import type { Ref } from '@nuxtjs/composition-api';
import { computed } from '@nuxtjs/composition-api';

import type { KlarnaConfigInterface } from '~/diptyqueTheme/composable/useKlarna/types';
import appendScript from '~/helpers/appendScript';

export const useKlarna = (config: Ref<KlarnaConfigInterface>, productPrice: Ref<number | string>) => {
  const scriptSrc = 'https://osm.klarnaservices.com/lib.js';
  const isKlarnaEnabled = computed(() => config.value?.klarna_pay_instalments_is_enabled ?? false);
  const isPriceEligibleForInstalments = computed(() => productPrice.value >= +config.value?.klarna_pay_instalments_min_price);

  const refreshKlarnaMessaging = () => {
    if (window.Klarna) {
      window.Klarna.OnsiteMessaging.refresh();
    }
  };

  const loadKlarnaScript = () => {
    // Ensure the code runs only on the client side
    if (!process.client) {
      return;
    }

    const klarnaClientId = config.value?.klarna_pay_instalments_client_id;

    if (!klarnaClientId || !isKlarnaEnabled.value || !isPriceEligibleForInstalments.value || document.querySelector(`script[src="${scriptSrc}"]`)) {
      return;
    }

    // Append the Klarna script to the document head
    appendScript(scriptSrc, true, true, {
      rel: 'dns-prefetch',
      'data-client-id': klarnaClientId
    });
  };

  return {
    isKlarnaEnabled,
    isPriceEligibleForInstalments,
    loadKlarnaScript,
    refreshKlarnaMessaging
  };
};
